import {AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BranchShipments, GetShipmentsOptions, ShipmentsService} from '../services/shipments.service';
import {MapboxGeoJSONFeature, MapLayerMouseEvent, Marker, Popup} from 'mapbox-gl';
import {Moment} from 'moment';
import {Shipment} from '../services/shipment';
import {ShipmentRoute} from '../services/shipment-route';
import {ShipmentRoutesService} from '../services/shipment-routes.service';
import * as moment from 'moment';
import * as MapboxGl from 'mapbox-gl';
import {environment} from '../../environments/environment';
import {BranchesService} from '../services/branches.service';
import {ShipmentDriversService} from '../services/shipment-drivers.service';
import * as _ from 'lodash';
import {forkJoin, Observable, of, Subscription} from 'rxjs';
import {ApiResponse, UsersService} from '@hassel-it/angular-common';
import {NgbModal, NgbNav} from '@ng-bootstrap/ng-bootstrap';
import {ShipmentDetailsPopupModalComponent} from "../shipment-details-popup-modal/shipment-details-popup-modal.component";

declare let NProgress: any;

@Component({
    providers: [ShipmentRoutesService, BranchesService, ShipmentDriversService],
    selector: 'app-shipping-system',
    templateUrl: './shipping-system.component.html',
    styleUrls: ['./shipping-system.component.scss'],
})
export class ShippingSystemComponent implements OnInit, OnDestroy, AfterViewInit {
    self;
    @ViewChild('outputImage') outputImage: ElementRef;
    @ViewChild('mapWrapper') mapWrapper: ElementRef;
    @ViewChild('shippingSidebar') shippingSidebar: NgbNav;

    showingAllRoutes = false;
    loadingShipments = false;
    expandOrderLines = false;
    lastUpdate = 0;
    showMissingWarning;

    private _showmap: boolean;

    showRouteEstimates = false;

    shipments: Shipment[];

    shipmentRoutes: ShipmentRoute[];
    drivers;

    routes;
    routeShipments;

    routeLegs;

    imageLoaded;
    coordinates: number[];
    color = '#3887be';

    map;
    pointsCollection: BranchShipments[];
    selectedPoint: MapboxGeoJSONFeature | any | null;
    cursorStyle: string;

    driverPoints: BranchShipments[];
    branchPoints: BranchShipments[];

    selectedBranchDriver: string = null;

    public environment;
    public alert: string = null;
    public alertType = 'danger';

    options: GetShipmentsOptions = null;
    isSearching = false;
    showStockStatus = false;
    searchOptions: GetShipmentsOptions = null;

    private shipmentsUpdatedObservable: Observable<boolean>;
    private shipmentsUpdatedSubscribtion: Subscription;

    isBranchLoaded: any = {};
    isDriverLoaded: any = {};
    filterPresets = [
        {name: 'Aktive', key: 'active'},
        {name: 'Leveret', key: 'complete'},
        // {name: 'bestilt varer hjem men de er endnu IKKE ankommet', key: 'stock_waiting'},
        // {name: 'bestilt varer hjem OG de er ankommet', key: 'stock_ready'},
        // {name: 'Leveret med ændringer', key: 'complete_with_changes'},
        {name: 'leveret, men IKKE slået i kassen', key: 'invoice_waiting'},
    ];
    showAllBranches: boolean = false;
    showAllCarriers: boolean = false;

    get showmap(): boolean {
        return this._showmap;
    }

    set showmap(val: boolean) {
        this._showmap = val;
        this.router.navigate([], {
            queryParams: {
                show_map: (val ? 1 : 0)
            },
            queryParamsHandling: 'merge'
        });
    }

    constructor(
        public usersService: UsersService,
        public activatedRoute: ActivatedRoute,
        public shipmentsService: ShipmentsService,
        public shipmentRoutesService: ShipmentRoutesService,
        public shipmentDriversService: ShipmentDriversService,
        public branchesService: BranchesService,
        private route: ActivatedRoute,
        private router: Router,
        public ngbModal: NgbModal) {

        this.environment = environment;
        this.shipmentsUpdatedObservable = this.shipmentsService.getShipmentsUpdatedStream();
    }

    ngAfterViewInit() {
        if (this.isSearching) {
            this.shippingSidebar.select('shippingSidebarSearch');
        }
    }

    ngOnInit() {

        this.initSearchQueryOptions();

        this.route.queryParamMap.subscribe(parmas => {
            const show_map = parmas.get('show_map');
            this.showmap = (show_map === '1');
        });

        this.initMapQueryOptions().subscribe(res => {

            let falback = true;
            /**
             * Grab order_reference from query
             */
            if (this.activatedRoute.snapshot.queryParams.hasOwnProperty('order_reference')) {
                /**
                 * Set order reference from query string into options and trigger search
                 */
                this.searchOptions.order_reference = this.activatedRoute.snapshot.queryParams.order_reference;
                this.isSearching = true;
                this.reloadShipments(true, true);
                falback = false;
            }

            if (this.activatedRoute.snapshot.queryParams.hasOwnProperty('nota_number')) {
                /**
                 * Set order reference from query string into options and trigger search
                 */
                this.searchOptions.nota_number = this.activatedRoute.snapshot.queryParams.nota_number;
                this.isSearching = true;
                this.reloadShipments(true, true);
                falback = false;

            }

            if (this.activatedRoute.snapshot.data.searchMode === true) {
                this.search(true);
                falback = false;
            }

            /**
             * Shipments
             */
            if (falback) {
            this.reloadShipments(true);
            }

            this.shipmentsUpdatedSubscribtion = this.shipmentsUpdatedObservable.subscribe((event) => {
                if (event === true) {
                    this.reloadShipments();
                }
            });

            /**
             * Shipment routes
             */
            this.shipmentRoutesService.getShipmentRoutes().then(shipmentRoutes => {
                this.shipmentRoutes = shipmentRoutes;

                const drivers = [];

                for (const shipmentRoute of shipmentRoutes) {
                    const branchIndex = drivers.findIndex((driver) => {
                        return driver['branch'] === shipmentRoute.branch;
                    });

                    if (branchIndex >= 0) {
                        const driverIndex = drivers[branchIndex]['drivers'].findIndex((driver) => {
                            return driver['driver'] === shipmentRoute.driver && driver['branch'] === shipmentRoute.branch;
                        });

                        if (driverIndex < 0) {
                            drivers[branchIndex]['drivers'].push({
                                'name': shipmentRoute.name,
                                'driver': shipmentRoute.driver,
                                'trip': shipmentRoute.trip,
                                'branch': shipmentRoute.branch,
                                'show': true
                            });
                        }
                    } else {
                        drivers.push({
                            'branch': shipmentRoute.branch,
                            'drivers': [
                                {
                                    'name': shipmentRoute.name,
                                    'driver': shipmentRoute.driver,
                                    'trip': shipmentRoute.trip,
                                    'branch': shipmentRoute.branch,
                                    'show': true
                                }
                            ]
                        })
                    }
                }

                this.drivers = drivers;

                //  Update the drivers showing based on options
                this.updateDriverCheckboxes();
            });

            /**
             * Branches
             */
            this.branchPoints = this.shipmentsService.getBranchesPoints();

            /**
             * Shipment drivers
             */
            const timer = setInterval(() => {
                console.log('Updating drivers');
                this.shipmentDriversService.getShipmentDrivers().then(shipmentDrivers => {
                    const driverPoints = [];

                    for (const shipmentDriver of shipmentDrivers) {
                        driverPoints.push({
                            paint: null,
                            featureCollection:
                                {
                                    'type': 'FeatureCollection',
                                    features: [{
                                        'type': 'Feature',
                                        'properties': {
                                            'id': shipmentDriver.id,
                                            'branch': shipmentDriver.branch,
                                            'driver_name': shipmentDriver.name, // shipmentDriver.shipment_routes[0].driver.toLowerCase()
                                            'driver': shipmentDriver.shipment_routes.length > 0 ? shipmentDriver.shipment_routes[0].driver.toLowerCase() : '-',
                                            'speed': shipmentDriver.speed,
                                            'direction': shipmentDriver.direction,
                                        },
                                        'geometry': {
                                            'type': 'Point',
                                            'coordinates': [shipmentDriver.last_y, shipmentDriver.last_x]
                                        }
                                    }]
                                }
                        });

                    }

                    this.driverPoints = driverPoints;
                });

            }, 10000);
        });
    }

    search(reset = false) {
        this.isSearching = true;
        this.options.isSearching = true;
        if (reset) {
            this.shipments = [];
        } else {
            this.showTable(null, null);
        }
    }

    isOneDay() {
        return this.options.startDate.format('YYYY-MM-DD') === this.options.endDate.format('YYYY-MM-DD');
    }

    tabChange(event) {
        //      if (event.nextId =='shippingSidebarSearch') {
        //          this.initSearchQueryOptions();
        //      } else {
        //          this.initMapQueryOptions();
        //      }
    }

    initSearchQueryOptions() {
        this.searchOptions = {
            valid_coordinates: false,
            order_reference: null,
            nota_number: null,
            product_number: null,
            contact_information_name: null,
            contact_information_adress: null,
            contact_information_phone: null,
            contact_information_email: null,
            tracking_number: null,
            isSearching: true,
            combineEvents: true
        };
    }

    initMapQueryOptions() {

        return new Observable(observer => {
            /**
             * Load options from local storage
             */
            const optionsString = localStorage.getItem('shipment-options-v5');

            if (optionsString) {
                const options: GetShipmentsOptions = JSON.parse(optionsString);

                options['startDate'] = moment(options['startDate']);
                options['endDate'] = moment(options['endDate']);

                options.isSearching = false;
                options.order_reference = null;
                options.nota_number = null;
                options.product_number = null;
                options.contact_information_adress = null;
                options.contact_information_name = null;
                options.contact_information_phone = null;
                options.contact_information_email = null;
                options.tracking_number = null;

                this.options = options;
                observer.next(true);
                observer.complete(); // Signal that the observable is complete

                //  We update the drivers a later in this function when we have the drivers set
            } else {
                this.resetOptions().then(() => {
                    observer.next(true);
                    observer.complete(); // Signal that the observable is complete
                })
            }
        });
    }

    shouldShowReset(): boolean {
        return !!(this.searchOptions.order_reference
            || this.searchOptions.nota_number
            || this.searchOptions.product_number
            || this.searchOptions.contact_information_name
            || this.searchOptions.contact_information_adress
            || this.searchOptions.contact_information_phone
            || this.searchOptions.contact_information_email
            || this.searchOptions.tracking_number
            || this.searchOptions.purchase_order
        );
    }

    resetSearch() {
        this.searchOptions.order_reference = null;
        this.searchOptions.nota_number = null;
        this.searchOptions.product_number = null;
        this.searchOptions.contact_information_adress = null;
        this.searchOptions.contact_information_name = null;
    }

    getBranchName(shorthand: string) {
        return this.branchesService.branches[shorthand];
    }

    public startDateChanged(date: Moment) {
        if (this.options.endDate.isAfter(this.options.startDate)) {
            return;
        }

        this.options.endDate = date;
    }

    endDateChanged($event: moment.Moment) {
        this.dateSearch();
    }

    onDragEnd(marker: Marker) {
        NgZone.assertInAngularZone();
        this.coordinates = marker.getLngLat().toArray();
    }

    closeDetail() {
        this.selectedPoint = null;
        NgZone.assertInAngularZone();
        setTimeout(() => {
            this.map.resize();
        }, 200);
    }



    today() {
        this.options.startDate = moment();
        this.options.endDate = moment();
    }

    tomorrow() {
        this.options.startDate = moment().add(1, 'days');
        this.options.endDate = moment().add(1, 'days');
    }

    thisWeek() {
        let weekday = moment().isoWeekday();

        this.options.startDate = weekday == 1 ? moment() : moment().subtract(weekday - 1, 'days');
        this.options.endDate = weekday == 7 ? moment() : moment().add(7 - weekday, 'days');
    }

    nextWeek() {
        let weekday = moment().isoWeekday();

        this.options.startDate = weekday == 1 ? moment().add(7, 'days') : moment().subtract(weekday - 1, 'days').add(7, 'days');
        this.options.endDate = weekday == 7 ? moment().add(7, 'days') : moment().add(7 - weekday, 'days').add(7, 'days');
    }

    dateSearch() {
        this.isSearching = false;
        this.expandOrderLines = false;
        this.options.isSearching = false;

        this.reloadShipments(true);

        /**
         * Hiding route
         */
        this.routes = [];
    }

    reloadShipments(zoom: boolean = false, displayPopover: boolean = false) {

        this.alert = null;
        this.loadingShipments = true;
        this.shipments = [];

        this.showMissingWarning = null;

        let options: GetShipmentsOptions;
        if (this.isSearching) {
            options = this.searchOptions;
            options.emptyBranch = false; // force searching all branches
        } else {
            options = this.options;
            this.shipmentsService.getShipmentsWithMissingCoordinates(1, {
                dateField: 'shipping_date',
                startDate: this.options.startDate,
                endDate: this.options.endDate,
                branch: this.options.branch
            }).then((resonse: ApiResponse) => {
                if (resonse.count > 0) {
                    this.showMissingWarning = resonse.count;
                }
            });
            // search for empty branches if no branches selected
            options.emptyBranch = options.branch.length === 0;
        }

        if (options.branch && options.branch.length > 1) {
            this.shipmentsService.paintData.active = false;
        }

        this.shipmentsService.getShipments(1, options).then((response) => {
            this.loadingShipments = false;

            const coordStrings = [];
            this.shipments = response.results.map((shiopment: Shipment) => {

                const coordString = shiopment.shipment_address.x + '-' + shiopment.shipment_address.y;
                shiopment.map_x = shiopment.shipment_address.x;
                shiopment.map_y = shiopment.shipment_address.y;
                coordStrings.push(coordString);

                const occrurences = coordStrings.reduce((acc, curr) => {
                    acc[curr] ? ++acc[curr] : acc[curr] = 1;
                    return acc
                }, {});

                if (occrurences[coordString] && occrurences[coordString] > 1) {
                    // shiopment.map_y = this.round(shiopment.map_y + (0.0002 * (occrurences[coordString] - 1)), 6); // @todo fix this
                }
                return shiopment;
            });
            this.pointsCollection = this.shipmentsService.FeatureCollectionFromShipments(this.shipments);

            if (zoom) {
                const geojson = this.shipmentsService.GeoJSONFromShipments(this.shipments);

                // this.zoomToBound(geojson);

                if (displayPopover) {
                    this.selectedPoint = geojson.features[0];

                    this.shippingSidebar.select('shippingSidebarSearch');
                }
            }
        }, () => {
            this.loadingShipments = false;
            this.shipments = [];
            this.pointsCollection = this.shipmentsService.FeatureCollectionFromShipments(this.shipments);
            this.alert = 'Shipments kunne ikke hentes med den givne søgning';
        });

        /**
         * Save options to local storage
         */
        localStorage.setItem('shipment-options-v5', JSON.stringify(this.options));
    }

    resetOptions() {
        localStorage.removeItem('shipment-options-v5');

        return this.usersService.getCurrentUser(true).then(user => {
            const userBranch = user.custom_fields.filter(field => field.key === 'branch').map((field) => {
                return field.value;
            }).find(Boolean)
            this.options = {
                valid_coordinates: false,
                statusFilter: 'new',
                all: true,
                startDate: moment(),
                endDate: moment(),
                dateField: 'shipping_date',
                showTenFourShipment: true,
                showPostNordShipment: false,
                showGLSShipment: false,
                showDanskeFragtmaendShipment: false,
                // actorId: number,
                // carrierId: string,
                // sort: string,
                // direction: string,
                branch: [userBranch],
                order_reference: null,
                nota_number: null,
                product_number: null,
                contact_information_name: null,
                contact_information_adress: null,
                contact_information_phone: null,
                contact_information_email: null,
                tracking_number: null,
                isSearching: false,
                combineEvents: true
            }
            return of(userBranch);
        });
    }

    toggleshowStockStatus() {
        this.showStockStatus = !this.showStockStatus;
        this.expandOrderLines = !this.expandOrderLines;
    }

    showMap() {
        this.showmap = !this.showmap;
    }

    showResetBranchDriversButton(): boolean {
        return !!(this.options.branch || this.options.driver);
    }


    resetBranchDrivers() {
        this.options.driver = null;
        this.options.branch = null;

        this.updateDriverCheckboxes();
    }

    showTable(branch: string, driver: string) {
        if (branch || driver) {
            this.isSearching = false;
            this.options.driver = driver;
            this.options.branch = [branch];
            this.updateDriverCheckboxes();

        }

        this.reloadShipments(true);
        this.showmap = false;

        /**
         * Hiding route
         */
        this.routes = [];
    }

    driversChanged() {
        if (!this.drivers) {
            return;
        }

        for (const branch of this.drivers) {
            if (branch.show && branch.show === true) {
                const infx = _.findIndex(this.options.branch, (n) => {
                    return n == branch.branch;
                });
                if (infx === -1) {
                    this.options.branch.push(branch.branch);
                }

            } else {
                _.remove(this.options.branch, (n) => {
                    return n == branch.branch;
                });
            }
        }
    }

    updateDriverCheckboxes() {
        if (!this.drivers) {
            return;
        }

        for (const branch of this.drivers) {

            const infx = _.findIndex(this.options.branch, (n) => {
                return n == branch.branch;
            });
            branch.show = infx !== -1;

            for (const driver of branch.drivers) {
                if (!this.options.branch && !this.options.driver) {
                    driver.show = true;
                    continue;
                }

                if (branch.branch != this.options.branch) {
                    driver.show = false;
                    continue;
                }

                if (!this.options.driver) {
                    driver.show = true;
                    continue;
                }

                driver.show = driver.driver == this.options.driver['driver'];
            }
        }
    }

    trackFn(idx: number, data: any) {
        return data.id;
    }




    routeChanged($event) {
        const routes = [];
        const legs = [];

        /**
         * Set shipment markers
         */
        this.pointsCollection = this.shipmentsService.FeatureCollectionFromShipments($event.shipments, true);

        /**
         * Route shipments
         */
        this.routeShipments = $event.shipments;

        /**
         * Set routes
         */
        for (const route of $event.routes) {
            legs.push(route.legs);

            routes.push({
                color: '#000000', //  @todo single route from table
                paint: {},
                featureCollection:
                    {
                        'type': 'FeatureCollection',
                        features: [{
                            'type': 'Feature',
                            'properties': {},
                            'geometry': {
                                'type': 'LineString',
                                'coordinates': route.geometry.coordinates
                            }
                        }]
                    }
            });

        }

        this.routes = routes;
        this.routeLegs = legs;

        this.showMap();
    }

    parseRouteDurationForIndex(index) {
        let durationInSeconds = 0;

        for (let i = 0; i <= index; i++) {
            durationInSeconds += this.routeLegs[0][i].duration;
        }

        for (let i = 0; i <= index; i++) {
            if (!this.routeShipments[i].dropoff_time) {
                continue;
            }

            durationInSeconds += this.routeShipments[i].dropoff_time * 60;
        }

        let string = '';
        let minutes = Math.round(durationInSeconds / 60);

        if (minutes > 59) {
            let hours = Math.floor(minutes / 60);

            minutes = minutes - (hours * 60);

            string = hours + ' time' + (hours > 1 ? 'r' : '') + ' ';
        }

        if (minutes > 0) {
            string += minutes + ' minut' + (minutes > 1 ? 'ter' : '');
        }

        return string;
    }

    parseRouteDistanceForIndex(index) {
        let distanceInMeters = 0;

        for (let i = 0; i <= index; i++) {
            distanceInMeters += this.routeLegs[0][i].distance;
        }

        let string = Math.round(distanceInMeters / 1000);

        return string + ' km';
    }

    isShowingRoute() {
        return this.routes && this.routes.length === 1;
    }

    hideRoute() {
        /**
         * showTable() sets routes array to an empty array
         */
        this.showTable(null, null);
    }

    hideAllRoutes() {
        this.showingAllRoutes = false;
        this.routes = [];
        this.reloadShipments(true);
    }

    showAllRoutes() {

        if (this.showingAllRoutes) {
            this.hideAllRoutes()
            return;
        }

        this.showingAllRoutes = true;
        const routeApiCalls = [];
        const newRoutes = [];

        /**
         * Route shipments
         */
        this.routeShipments = null; //  @todo route sidevar behavior with many routes ?
        const colors = [];
        /**
         * Set routes
         */
        for (const shipmentRoute of this.shipmentRoutes) {
            const shipments = this.shipments.filter(e => e.shipment_route_id === shipmentRoute.id);

            if (shipments.length > 0 && shipments.length < 25) {
                colors.push(shipmentRoute.route_color);
                routeApiCalls.push(this.shipmentRoutesService.getRoute(shipments, shipmentRoute.branch));
            }
        }

        forkJoin(routeApiCalls).subscribe((routes) => {
            routes.forEach((response, index) => {
                newRoutes.push({
                    color: colors[index],
                    paint: {},
                    featureCollection: {
                        'type': 'FeatureCollection',
                        features: [{
                            'type': 'Feature',
                            'properties': {},
                            'geometry': {
                                'type': 'LineString',
                                'coordinates': response.routes[0].geometry.coordinates
                            }
                        }]
                    }
                });
            });
            this.routes = newRoutes;
            this.reloadShipments(true);
            this.showmap = true;
        });
    }

    /**
     * Prints the currently displayed map
     * @todo WIP
     */
    printMap() {
        // get the map as a png dataUrl
        this.outputImage.nativeElement.src = this.map.getCanvas().toDataURL('image/png');
        // send png to print url
        // return pdf data or download link
    }

    ngOnDestroy() {
        if (this.shipmentsUpdatedSubscribtion) {
            this.shipmentsUpdatedSubscribtion.unsubscribe();
        }
    }

    changeCursr() {
        if (this.shipmentsService.paintData.active && this.shipmentsService.paintData.shipmentRoute) {
            const icon = this.shipmentsService.iconSlugForRoute(this.shipmentsService.paintData.shipmentRoute);
            const base = environment.assetBase;
            this.cursorStyle = 'url(\'' + base + '/assets/img/map-icons/' + icon + '.gif\') 25 25, auto';
        } else {
            this.cursorStyle = 'pointer';
        }
    }

    public performPaint(shipmentId: any) {

        if (!this.shipmentsService.paintData.active) {
            alert('Paint not active');
            return false;
        }

        if (!this.shipmentsService.paintData.shipping_date || !this.shipmentsService.paintData.shipping_date.isValid()) {
            alert('Du skal vælge en dato');
            return false;
        }

        if (!this.shipmentsService.paintData.shipmentRoute || !this.shipmentsService.paintData.shipmentRoute.id) {
            alert('Du skal vælge en rute');
            return false;
        }

        this.loadingShipments = true;
        this.shipmentsService.getShipment(shipmentId, {combineEvents: true}).then((shiptmend: Shipment) => {
            if (
                this.shipmentsService.paintData.shipmentRoute && this.shipmentsService.paintData.shipmentRoute.id
            ) {
                shiptmend.shipment_route_id = this.shipmentsService.paintData.shipmentRoute.id;
            }

            if (this.shipmentsService.paintData.shipping_date && this.shipmentsService.paintData.shipping_date.isValid()) {
                shiptmend.shipping_date = this.shipmentsService.paintData.shipping_date;
            }

            this.shipmentsService.updateShipment(shiptmend).then(() => {
                this.lastUpdate++;
                this.reloadShipments();
            })
        })
    }


    branchLoaded(i) {
        this.isBranchLoaded[i] = true
    }

    driverLoaded(i: number) {
        this.isDriverLoaded[i] = true
    }

    round(num: number, fractionDigits: number): number {
        return Number(num.toFixed(fractionDigits));
    }
}
